import { useQuery } from 'src/hooks/use-query'
import { ExplanationType } from 'src/lib/gql-client'

import { ExplanationRoomFinished } from '../ExplanationRoomFinished/ExplanationRoomFinished'

export const ExplanationRoomFinishedScreen: React.FC = () => {
  const query = useQuery()

  const isLeft = query.get('isLeft') === 'true'
  const type = query.get('type')
    ? (query.get('type') as ExplanationType)
    : undefined
  const isPartnerMember = query.get('isPartnerMember') === 'true'

  // 患者と同じ場所いるケース（対面 or パートナー施設側のユーザー）
  const shouldLogout =
    type === 'InPerson' || (type === 'RemotePartner' && isPartnerMember)

  const returnUrl = query.get('returnUrl') || undefined

  return (
    <ExplanationRoomFinished
      shouldLogout={shouldLogout}
      isLeft={isLeft}
      returnUrl={returnUrl}
    />
  )
}
